import { render, staticRenderFns } from "./Estudante-pesquisa.vue?vue&type=template&id=7a9e730c&scoped=true&"
import script from "./Estudante-pesquisa.vue?vue&type=script&lang=js&"
export * from "./Estudante-pesquisa.vue?vue&type=script&lang=js&"
import style0 from "./Estudante-pesquisa.vue?vue&type=style&index=0&id=7a9e730c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9e730c",
  null
  
)

export default component.exports